module.exports = __webpack_public_path__ + "img/img-google-play.97cafeb5.png";